import { getLoyaltyBonusPointsCampaignTypes } from 'loyalty/lib/determineLoyaltyBonusPointsCampaignType'

function getOrderLoyaltyPendingPointsCampaignTypes(
  pendingPointsItems: Array<App.OrderLoyaltyPendingPoints>,
): Array<App.LoyaltyBonusPointsCampaignType> {
  const campaignTypes = pendingPointsItems.flatMap(item => getLoyaltyBonusPointsCampaignTypes({
    basePoints: item.basePoints,
    bonusPoints: item.bonusPoints,
    bonusStatusCredits: item.bonusStatusCredits,
    statusCredits: item.statusCredits,
  }))

  return Array.from(new Set(campaignTypes))
}

export default getOrderLoyaltyPendingPointsCampaignTypes
